import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileConfig } from './../../profile.config';

@Component({
  selector: 'view-profile-driver-license',
  templateUrl: './view-profile-driver-license.component.html',
  providers: []
})

export class ViewProfileDriverLicenseComponent {
  @Input() viewProfileData: Object;
  profileKey: string;

  constructor() {
  }

  ngOnInit() {
    this.profileKey = ProfileConfig.getViewProfileDriverLicenseKey();
  }
}